import React from 'react';
import { StyleError, StyleErrorText } from './style';
import Icon from '../../../core/Icon';
import { SadFace } from '../../../../../assets/images/index';

const Error = () => (
  <StyleError>
    <Icon svg={SadFace} size="l" />
    <StyleErrorText>¡Ups!</StyleErrorText>
    <StyleErrorText>Parece que ha habido un error</StyleErrorText>
  </StyleError>
);

export default Error;
